export default __webpack_public_path__ + "static/media/carousel5.503b5f2e.jpg";